import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ImpactGrowth extends Vue {
  public isShowProgress: boolean = false;
  public isprogress: boolean = false;
  public isMathExp: boolean = false;

  public hideProgress() {
    this.isShowProgress = false;
    this.isprogress = false;
    this.isMathExp = false;
  }

  public showProgress() {
    this.isShowProgress = true;
    this.isprogress = false;
    this.isMathExp = false;
  }

  public mathProgress() {
    this.isprogress = true;
    this.isShowProgress = false;
    this.isMathExp = false;
  }

  public showMathProgress() {
    this.isMathExp = true;
    this.isShowProgress = false;
    this.isprogress = false;
  }
}
